import {
  Button,
  FieldGroup,
  FieldRow,
  FieldSet,
  Section,
} from "react-corner-ds";
import { Trans } from "react-i18next";
import style from "./GenericComponent.module.css";

interface IGenericComponent {
  pageTitle: string;
  pageSubtitle: string;
  transComponent?: any;
  buttonLabel?: string;
  onClickCallback?: () => void;
  ImageSrc?: string | React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  icon?: string;
}

const GenericComponent: React.FC<IGenericComponent> = ({
  pageTitle,
  pageSubtitle,
  transComponent,
  buttonLabel,
  onClickCallback,
  ImageSrc,
  icon,
}) => {
  return (
    <>
      <Section customCssClass={style.genericComponent}>
        <FieldSet>
          {ImageSrc && (
            <FieldRow customCssClass={style.genericImg}>
              <FieldGroup>{<ImageSrc />}</FieldGroup>
            </FieldRow>
          )}
          {icon && (
            <FieldRow>
              <FieldGroup>
                <h1>
                  <i className={icon}></i>
                </h1>
              </FieldGroup>
            </FieldRow>
          )}
          <FieldRow>
            <FieldGroup>
              <h1>
                <Trans i18nKey={pageTitle} components={transComponent} />
              </h1>
            </FieldGroup>
          </FieldRow>
          <FieldRow>
            <FieldGroup>
              <h2>
                <Trans i18nKey={pageSubtitle} components={transComponent} />
              </h2>
            </FieldGroup>
          </FieldRow>

          {buttonLabel && onClickCallback && (
            <FieldRow customCssClass={style.btnHolder}>
              <FieldGroup>
                <Button
                  text={buttonLabel}
                  type="button"
                  onClick={onClickCallback}
                />
              </FieldGroup>
            </FieldRow>
          )}
        </FieldSet>
      </Section>
    </>
  );
};

export default GenericComponent;
